<template>
  <div id="app" v-loading="isLoading" element-loading-background="rgba(0,0,0,0)">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      $_reload: this.$_reload,
      $showLoading: this.$showLoading,
      $hideLoading: this.$hideLoading
    }
  },
  data () {
    return {
      isRouterAlive: true,
      isLoading: false
    }
  },
  methods: {
    $_reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    $showLoading () {
      this.isLoading = true
    },
    $hideLoading () {
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss">
 #app {
   height: 100%;
   width: 100%;
 }
@import './style/index.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue